export default __webpack_public_path__ + "static/media/612.c901bd98.png";